import Vue from 'vue'
import Router from 'vue-router'
import { guardUser } from '@/router-auth-guard.js'

// import store from '@/store/store'


import Notifications  from '@/components/View_Notifications/View_Notifications.vue'
import Timeline       from '@/components/View_Timeline/View_Timeline.vue'
import Profile        from '@/components/View_Profile/View_Profile.vue'
import FriendProfile    from '@/components/View_Profile/View_FriendProfile.vue'
import Friends        from '@/components/View_Friends/View_Friends.vue'
import Favorites      from '@/components/View_Favorites/View_Favorites.vue'
import Event          from '@/components/View_Details/View_Event.vue'
import Error404       from '@/components/View_Errors/View_Error404.vue'
import Add            from '@/components/View_Add/View_Add.vue'
import Authentication from '@/components/View_Authentication/View_Authentication.vue'



Vue.use(Router)




const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Authentication
    },
   
    {
      path: '/notifications',
      name: 'Notifications',
      component: Notifications,
      beforeEnter: guardUser
    },
    {
      path: '/timeline',
      name: 'Timeline',
      component: Timeline,
      beforeEnter: guardUser,
    },
    {
      path: '/add',
      name: 'Add',
      component: Add,
      beforeEnter: guardUser
    },
    {
      path: '/event/:id',
      name: 'Event',
      props: true,
      component: Event,
      beforeEnter: guardUser
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: guardUser,
      
    },
    {
      path: '/profile/:uniqueId',
      name: 'FriendProfile',
      props: true,
      component: FriendProfile,
      beforeEnter: guardUser
    },
    {
      path: '/favorites',
      name: 'Favorites',
      component: Favorites,
      beforeEnter: guardUser
    },
    {
      path: '/friends',
      name: 'Friends',
      component: Friends,
      beforeEnter: guardUser
    },
    {
      path: '/404',
      name: '404',
      component: Error404
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    console.log('scrollBehaviorfrom', from)
    console.log('scrollBehaviorto', to)
    console.log('scrollBehaviorsavedPosition', savedPosition)
    if (from.path === '/timeline') {
      return { x: 0, y: 0 }
    } else if (to.path === '/timeline') {
      // Hier könnte zum vorherigen Objekt gescrollt werden
      // Problem: es werden Posts in der Timeline erst nach und nach geladen -> ScrollPosition derzeit noch gar nicht verfügbar
      // Lösung: "keep alive" oder mit scroll-animation nach unten scrollen oder ... ???
      // return new Promise((resolve, reject) => {
      //   setTimeout(() => {
      //     resolve({ x: 0, y: store.state.timeline.timelineScrollY })
      //   }, 2000)
      // })
      // return { x: 0, y: store.state.timeline.timelineScrollY }
      return { x: 0, y: 0 }
    } else {
      return { x: 0, y: 0 }
    }
    
  }
})

// router.beforeEach((to, from, next) => {
//   // window.scrollY(0)
//   next()
// })

// Only load in 'development'-mode
if (process.env.NODE_ENV === 'development') {
  router.addRoutes([
    {
      path: '/test',
      name: 'test',
      component: () => import('@/components/View_Test/View_Test.vue')

    },
    {
      path: '/blog',
      name: 'Blog',
      // component: Blog,
      component: () => import('@/components/View_Blog/View_Blog.vue')
      // beforeEnter: guardUser
    },
  ])
}


export default router

// export default new Router({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes: [
//     {
//       path: '/',
//       name: 'Home',
//       component: Authentication
//     },
//     {
//       path: '/blog',
//       name: 'Blog',
//       component: Blog,
//       // beforeEnter: guardUser
//     },
//     {
//       path: '/notifications',
//       name: 'Notifications',
//       component: Notifications,
//       beforeEnter: guardUser
//     },
//     {
//       path: '/timeline',
//       name: 'Timeline',
//       component: Timeline,
//       beforeEnter: guardUser
//     },
//     {
//       path: '/add',
//       name: 'Add',
//       component: Add,
//       beforeEnter: guardUser
//     },
//     {
//       path: '/event/:id',
//       name: 'Event',
//       props: true,
//       component: Event,
//       beforeEnter: guardUser
//     },
//     {
//       path: '/profile',
//       name: 'Profile',
//       component: Profile,
//       beforeEnter: guardUser
//     },
//     {
//       path: '/profile/:uniqueId',
//       name: 'FriendProfile',
//       props: true,
//       component: FriendProfile,
//       beforeEnter: guardUser
//     },
//     {
//       path: '/favorites',
//       name: 'Favorites',
//       component: Favorites,
//       beforeEnter: guardUser
//     },
//     {
//       path: '/friends',
//       name: 'Friends',
//       component: Friends,
//       beforeEnter: guardUser
//     },
//     {
//       path: '/test',
//       name: 'test',
//       component: Test
//     },
//     {
//       path: '/404',
//       name: '404',
//       component: Error404
//     },
//     {
//       path: '*',
//       redirect: '/404'
//     }
//   ]
// })
